/* eslint-disable no-async-promise-executor */
/**
 * 注册、登录、注销
 * */
import router from '@/router'
import request from '@/fly'
import cookies from '@/libs/util.cookies'

import { Dialog, Toast } from 'vant'

// store
// import store from '@/store/index';

export default {
    namespaced: true,
    actions: {
        /**
         * @description 登录
         * @param {Object} param context
         * @param {Object} param username {String} 用户账号
         * @param {Object} param password {String} 密码
         * * @param {Object} param vrifyCode {String} 验证码
         * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
         */
        login({ state, commit, dispatch }, {
            username = '',
            password = '',
            vrifyCode = '',
            uuid = '',
            phone = '',
            dynamicPassword = '',
            wxopenid = ''
        } = {}) {
            return new Promise((resolve, reject) => {
                // 开始请求登录接口
                let data = {}
                if (username) {
                    data = {
                        username,
                        password,
                        vrifyCode,
                        uuid,
                        wxopenid
                    }
                } else {
                    data = {
                        phone,
                        dynamicPassword,
                        wxopenid
                    }
                }
                request.post('mobileLogin', data).then(async res => {
                  // 设置 cookie 一定要存 uuid 和 token 两个 cookie
                  // 整个系统依赖这两个数据进行校验和存储
                  // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
                  // token 代表用户当前登录状态 建议在网络请求中携带 token
                  // 如有必要 token 需要定时更新，默认保存一天，可在 setting.js 中修改
                  // 如果你的 token 不是通过 cookie 携带，而是普通字段，也可视情况存储在 localStorage
                  localStorage.setItem('token', JSON.stringify(res.data.token))
                  localStorage.setItem('uuid', JSON.stringify(res.data.user.id))
                  localStorage.setItem('user', JSON.stringify(res.data.user))
                  // localStorage.setItem('USER_ROUTER', JSON.stringify(res.data.usrVueRouter[0].children))
                  // localStorage.setItem('USER_PERMISSIONS', JSON.stringify(res.data.permissions))

                  // 设置 vuex 用户信息
                  await dispatch('admin/user/set', res.data.user, { root: true })
                  // 用户登录后从持久化数据加载一系列的设置
                  await dispatch('load')

                  resolve(res.data)
                }).catch(err => {
                  console.log('err: ', err);
                  reject(err)
                })
            })
        },
        userIn({ dispatch }) {
            return new Promise((resolve, reject) => {
                // 开始请求登录接口
                request.get(
                        '/user', {})
                    .then(async res => {
                        // console.log(res)
                        resolve()
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        /**
         * @description 退出登录
         * */
        logout({ commit, dispatch }) {
          Dialog.confirm({ title: '是否退出程序' })
            .then(async () => {
              localStorage.removeItem('token');
              localStorage.removeItem('uuid');
              localStorage.removeItem('user');
              localStorage.removeItem('SHOW_TENANT');
              localStorage.removeItem('SHOW_TENANTS');
              localStorage.removeItem('TENANT_MODEL');
              localStorage.removeItem('USER_TENANTS');
              await dispatch('admin/user/set', {}, { root: true })
              await router.push('/login')
          })
        },
        /**
         * @description 注册
         * @param {Object} param context
         * @param {Object} param mail {String} 邮箱
         * @param {Object} param password {String} 密码
         * @param {Object} param mobile {String} 手机号码
         * @param {Object} param captcha {String} 验证码
         */
        register({ commit, dispatch }, {
            mail = '',
            password = '',
            mobile = '',
            captcha = ''
        } = {}) {
            return new Promise((resolve, reject) => {
                // 开始请求登录接口
                request.post('mobileLogin', {
                        mail,
                        password,
                        mobile,
                        captcha
                    }).then(async res => {
                        // 注册成功后，完成与登录一致的操作
                        // 注册也可视情况不返还 uuid、token 等数据，在注册完成后，由前端自动执行一次登录逻辑
                        localStorage.setItem('uuid', JSON.stringify(res.uuid))
                        localStorage.setItem('token', JSON.stringify(res.token))
                            // 设置 vuex 用户信息
                        await dispatch('admin/user/set', res.info, { root: true })
                            // 用户登录后从持久化数据加载一系列的设置
                        await dispatch('load')
                            // 结束
                        resolve(res)
                    })
                    .catch(err => {
                        // console.log('err: ', err);
                        reject(err)
                    })
            })
        },
        /**
         * @description 用户登录后从持久化数据加载一系列的设置
         * @param {Object} state vuex state
         * @param {Object} dispatch vuex dispatch
         */
        load({ state, dispatch }) {
            return new Promise(async resolve => {
                // 加载用户登录信息
                await dispatch('admin/user/load', null, { root: true });
                // end
                resolve();
            })
        }
    }
}
